import { render, staticRenderFns } from "./goodsCombinationAdd.vue?vue&type=template&id=0d1176bb&scoped=true"
import script from "./goodsCombinationAdd.vue?vue&type=script&lang=js"
export * from "./goodsCombinationAdd.vue?vue&type=script&lang=js"
import style0 from "./goodsCombinationAdd.vue?vue&type=style&index=0&id=0d1176bb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1176bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d1176bb')) {
      api.createRecord('0d1176bb', component.options)
    } else {
      api.reload('0d1176bb', component.options)
    }
    module.hot.accept("./goodsCombinationAdd.vue?vue&type=template&id=0d1176bb&scoped=true", function () {
      api.rerender('0d1176bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/goodsCombinationAdd.vue"
export default component.exports